import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquareCheck, faCircleStop, faCalendarDays } from '@fortawesome/free-solid-svg-icons';
import { faSquare } from '@fortawesome/free-regular-svg-icons';
import { CerebroIcon } from '../../shared/components';
import { MilestoneStatusResponses, MilestoneTypes, MilestoneTypesMap } from '../../shared/models';
import { GetMilestoneStatusResponsesDescription } from '../../shared/utils/enum';
import { TableCell } from '@mui/material';

interface MilestoneIconProps {
	milestoneType: MilestoneTypes;
	inProgress: boolean;
	response: MilestoneStatusResponses;
}

export const TableCellMilestoneIcon: React.FC<MilestoneIconProps> = ({ milestoneType, inProgress, response }) => {
	const titleText = MilestoneTypesMap[milestoneType] + ' ' + GetMilestoneStatusResponsesDescription(response);
	const callInProgress = milestoneType == 'ReadyForCall' && inProgress;

	return (
		<>
			{callInProgress && (
				<TableCell sx={theme => ({ textAlign: 'center', backgroundColor: theme.palette.info.main })}>
					<CerebroIcon
						padRight
						sx={theme => ({ color: theme.palette.background.default })}
						title="In Progress"
					>
						<FontAwesomeIcon icon={faCalendarDays} size="lg" />
					</CerebroIcon>
				</TableCell>
			)}

			{response === 'Yes' && !callInProgress && (
				<TableCell sx={theme => ({ textAlign: 'center', backgroundColor: theme.palette.green.main })}>
					<CerebroIcon padRight sx={theme => ({ color: theme.palette.background.default })} title={titleText}>
						<FontAwesomeIcon icon={faSquareCheck} size="lg" />
					</CerebroIcon>
				</TableCell>
			)}

			{response === 'OptOut' && !callInProgress && (
				<TableCell sx={theme => ({ textAlign: 'center', backgroundColor: theme.palette.error.main })}>
					<CerebroIcon padRight sx={theme => ({ color: theme.palette.background.default })} title={titleText}>
						<FontAwesomeIcon icon={faCircleStop} size="lg" />
					</CerebroIcon>
				</TableCell>
			)}

			{response === 'NotAnswered' && !callInProgress && (
				<TableCell sx={theme => ({ textAlign: 'center' })}>
					<CerebroIcon padRight sx={theme => ({ color: theme.palette.gray.medium })} title={titleText}>
						<FontAwesomeIcon icon={faSquare} size="lg" />
					</CerebroIcon>
				</TableCell>
			)}

			{response === 'NotYet' && !callInProgress && (
				<TableCell sx={theme => ({ textAlign: 'center' })}>
					<CerebroIcon padRight sx={theme => ({ color: theme.palette.gray.medium })} title={titleText}>
						<FontAwesomeIcon icon={faSquare} size="lg" />
					</CerebroIcon>
				</TableCell>
			)}
		</>
	);
};
